import React from "react";
import { Route, Switch } from "react-router-dom";
import EquipmentTable from "./EquipmentTable";
import EquipmentForm from "./EquipmentForm";
import WriteRoute from "../../../shared/components/WriteRoute";

export default () => (
  <Switch>
    <Route exact path="/assets/equipment" component={EquipmentTable} />
    <WriteRoute
      exact
      path="/assets/equipment/addnew"
      component={EquipmentForm}
      redirectTo="/assets/equipment"
    />
  </Switch>
);
